/* eslint-disable */
<template>
  <div id="app">
    
    <keep-alive>
      <Sidebar id="sideBarId" ref="sideBarRef" v-touch:swipe.left="swipeHandler">
      </Sidebar>
    </keep-alive>
    
    <!--
    <NavigationBar v-if="loggedIn">
      <template v-slot:left>
        // menu, profile, macthdayselect, text (center, 2-zeilen, back)
        <button v-if="" v-on:click="openMenu">Menu</button>
        <button v-else-if="" v-on:click="openMenu">Menu</button>
      </template>
      <template v-slot:center>
        Tippabgabe<br>{{ matchday }}. Spieltag ({{ matchdayCount }})
      </template>
      <template v-slot:right>
        <button v-on:click="openMatchdaySelect">Select</button>
      </template>
    </NavigationBar>
    -->
    
    <router-view v-bind:class="{ pageoffset: true }" class="page" />

    <transition v-if="isLoading" name="review-modal">
      <LoadingModal></LoadingModal>
    </transition>
    
  </div>
</template>

<script>
import { authComputed } from '@/vuex/helpers.js'
import NavigationBar from './components/NavigationBar'
import { menumutations } from '@/vuex/store.js'
import { TOAST_DURATION } from './main'
import Sidebar from './components/Menu/Sidebar'
import { bootstrap } from 'vue-gtag'
import Numeral from 'numeral'
import moment from 'moment'
import jwt_decode from 'jwt-decode'
import LoadingModal from '@/components/LoadingModal.vue'

export default {
  components: { LoadingModal, NavigationBar, Sidebar },
  data() {
    return {
      showValidationHint: true,
      interval: null
    }
  },
  metaInfo () {
    return {
      title: 'Dein Tippspiel',
      titleTemplate: '%s | Teamtip',
      meta: [
        { property: 'og:title', content: 'Teamtip' },
        { property: 'og:type', content: 'website' },
        { property: 'og:url', content: 'https://teamtip.net/' },
        { property: 'og:image', content: 'https://teamtip.net/images/Teamtip_Logo_300x300.png' },
        { property: 'og:image:url', content: 'https://teamtip.net/images/Teamtip_Logo_300x300.png' },
        { property: 'og:image:width', content: '300' },
        { property: 'og:image:height', content: '300' },
        { property: 'og:site_name', content: 'Teamtip' },
        {
          property: 'og:description',
          content: 'Teamtip - dein kostenloses Tippspiel zur WM, Bundesliga, 2. Bundesliga, Champions League, Premier League, Primera División, La Liga, SüperLig, Serie A und Ligue 1 für Freunde, Familie und Kollegen mit unbegrenzter Teilnehmerzahl.'
        },
        //{ property: 'fb:app_id', content: '151742964909413' },        
        {
          vmid: 'keywords',
          name: 'keywords',
          content: 'kostenloses Tippspiel, Fussball, Online, Bundesliga, 2. Bundesliga, Champions League, Premier League, Primera División, La Liga, SüperLig, Serie A, Ligue 1, EURO 2024, WM, EM, Spiel, Kick, Tipp, Tippen, Umsonst, Tippkönig, Spieltagssieger, Halbzeit, Abpfiff, Live-Ergebnisse, Privat, unbegrentze Teilnehmerzahl, Online, Web, Tip, Social, Network, Mobile, App'
        },
        {
          vmid: 'description',
          name: 'description',
          content: 'Teamtip - dein kostenloses Tippspiel zur WM, Bundesliga, 2. Bundesliga, Champions League, Premier League, Primera División, La Liga, SüperLig, Serie A und Ligue 1 für Freunde, Familie und Kollegen mit unbegrenzter Teilnehmerzahl.'
        },
      ]
    }
  },
  computed: {
    ...authComputed,
    darkmode () {
      return this.$store.state.darkmode === true
    },
    isLoading () {
      const t = this.$store.state.showLoadingOverlay === true && this.$store.state.showLoadingOverlayStatus < 5
      if(!t) {
        var element = document.getElementById("pagebody")
        element.classList.remove("bodybackground")
      }
      return t
    }
  },
  beforeCreate: function() {
    document.title = this.$i18n.t('app_name')
    this.$log.debug('app beforeCreate ' + this.$route.query.code + ' --- ' + this.$route.query.email + ' --- ' + document.domain)
    const api = 'https://teamtip.net'
    if(api !== undefined) {
      if(api.startsWith('http')) {
        window.localStorage.setItem('spmau', api)
      } else {
        window.localStorage.setItem('spmau', 'https://' + api)
      }
    } else {
      const apiUrl = window.localStorage.getItem('spmau')
      if(apiUrl === undefined || apiUrl === null || apiUrl === 'undefined') {
        const domain = document.domain
        if (domain !== undefined && (domain.includes('teamtip') || domain.includes('tippspiel') || domain.includes('deinsportplatz.de'))) {
          window.localStorage.setItem('spmau', 'https://' + domain)
        } else {
          window.localStorage.setItem('spmau', 'https://teamtip.net')
        }
      }
    }
    var id = this.$route.query.id
    if(id === undefined) {
      id = this.$route.query.betgameid
      if(id === undefined) {
        id = window.localStorage.getItem('spmbgid')
        if(id === undefined) {
          id = undefined
        }
      }
    }
    window.localStorage.setItem('spmbgid', id)
    if(navigator.userAgent.indexOf('TEAMTIP') > 0 || navigator.userAgent.indexOf('Teamtip') > 0) {
      window.cmp_noscreen = true
      window.localStorage.setItem('betgameId', id)
      try {
        if (window.webkit && window.webkit.messageHandlers.TeamtipAppInterface !== undefined && window.webkit.messageHandlers.TeamtipAppInterface !== null) {
          const b = window.webkit.messageHandlers.TeamtipAppInterface.postMessage('getTrackingAuthorizationStatus')
        }
      } catch (e) {
      }
    }
    const src = this.$route.query.src
    if(src !== undefined) {
      window.localStorage.setItem('userSource', src)
    }
    if(this.$route.query.utm_source) {
      window.localStorage.setItem('userSource', this.$route.query.utm_source)
    }
  },
  created () {
    const savedDark = window.localStorage.getItem('spmdarkmode')
    if (savedDark === 'true') {
      this.$store.dispatch('setDarkmode', true)
    } else if (savedDark === 'false') {
      this.$store.dispatch('setDarkmode', false)
    }
    this.$log.debug('app created ' + this.$route.params.id + ' --- ' + this.$route.name + ' --- ' + this.$route.query.code + ' --- ' + this.$route.query.email)
    var element = document.getElementById("pagebody")
    element.classList.remove("bodybackground")
    if(this.getBGValue('spmau')) {
      this.$store.dispatch('setApiUrl', this.getBGValue('spmau'))
    }
    if(false && this.isSPMUser()) {
      window.appResumeEvent = new Event('appResumeEvent')
      window.addEventListener('appResumeEvent', this.appResumeEventFunction, false)
      window.appPullToRefreshEvent = new Event('appPullToRefreshEvent')
      window.addEventListener('appPullToRefreshEvent', this.appPullToRefreshEventFunction, false)
    }
    if((this.$route.name === 'validateregistration' || this.$route.name === 'validateemailregistration' || this.$route.name === 'vr') && this.$route.query.code && this.$route.query.email) {
      this.showValidationHint = false
      this.$store.dispatch('validateRegistration',
              {
                email: String(this.$route.query.email).toLowerCase(),
                token: this.$route.query.code
              }
      ).then(() => {
        this.$toast.open({ message: this.$i18n.t('register.registration_finished_good_luck'), position: 'top', duration: TOAST_DURATION, type: 'success' })
        if(this.$store.getters.loggedIn && this.$store.state.user && !this.$store.state.user.acceptedtos) {
          this.$router.push({ name: 'finishregistration' })
        } else if(this.$store.getters.loggedIn && this.$store.state.user && this.$store.state.user.acceptedtos) {
          this.$router.push({ name: 'dashboard' }).catch(err => {})
        } else {
          this.$router.push({ name: 'home', query: { email: this.$route.query.email } })
        }
      }).catch(function (error) {
      })
    }
    if(this.$store.getters.loggedIn && this.$store.state.user.id) {
      if(this.$store.state.user.lang) {
        this.$store.state.language = this.$store.state.user.lang
        Numeral.locale(this.$store.state.user.lang)
        moment.locale(this.$store.state.user.lang)
        if(this.$i18n.locale !== this.$store.state.user.lang) {
          this.$log.debug('app created set i18n.locale ' + this.$store.state.user.lang)
          this.$i18n.locale = this.$store.state.user.lang
        } else {
          this.$log.debug('app created use i18n.locale ' + this.$store.state.user.lang)
        }
      }
      bootstrap().then(gtag => {
        this.$gtag.set({
          'user_id': '' + this.$store.state.user.id,
          'anonymize_ip': true,
          'dimension1': this.$store.state.betgame && this.$store.state.betgame.name ? this.$store.state.betgame.name : 'betgame not set',
          'dimension2': this.$store.state.user && this.$store.state.user.source ? this.$store.state.user.source : 'user source not set',
          'dimension3': this.$store.state.betgame && this.$store.state.betgame.id ? this.$store.state.betgame.id : 'betgame id not set',
          'dimension5': this.$store.state.betgame && this.$store.state.betgame.type ? this.$store.state.betgame.type : 'betgame type not set'
        })
        if(this.$store.state.betgame && this.$store.state.user) {
          this.$gtag.set({
            user_properties: {
              permission_manage_prediction_round: '' + this.isAdmin(this.$store.state.betgame.id),
              prediction_mode: this.getBetgameType(this.$store.state.betgame),
              prediction_competiton: this.getCompetitionId(this.$store.state.betgame.id),
              notification_preferences: this.getNotificationPreferences(),
              news_push: (this.$store.state.user.news_push_notifications !== undefined && this.$store.state.user.news_push_notifications === true) ? '1' : '0',
              user_age: (this.$store.state.user.isadult) ? '>=18' : '<18',
              test_spm: (this.isSPMUser()) ? '1' : '0'
            },
          })
          if (window.webkit && window.webkit.messageHandlers.TeamtipAppInterface !== undefined && window.webkit.messageHandlers.TeamtipAppInterface !== null) {
            const c = window.webkit.messageHandlers.TeamtipAppInterface.postMessage({
              'type': 'setFirebaseUserProperty',
              'permission_manage_prediction_round': '' + this.isAdmin(this.$store.state.betgame.id),
              'prediction_mode': this.getBetgameType(this.$store.state.betgame),
              'prediction_competiton': '' + this.getCompetitionId(this.$store.state.betgame.id),
              'notification_preferences': this.getNotificationPreferences(),
              'news_push': (this.$store.state.user.news_push_notifications !== undefined && this.$store.state.user.news_push_notifications === true) ? '1' : '0',
              'user_age': (this.$store.state.user.isadult) ? '>=18' : '<18',
              'test_spm': (this.isSPMUser()) ? '1' : '0'
            })
          } else if (window.TeamtipAppInterface !== undefined && window.TeamtipAppInterface !== null) {
            const data = {
              type: 'setFirebaseUserProperty',
              permission_manage_prediction_round: '' + this.isAdmin(this.$store.state.betgame.id),
              prediction_mode: this.getBetgameType(this.$store.state.betgame),
              prediction_competiton: '' + this.getCompetitionId(this.$store.state.betgame.id),
              notification_preferences: this.getNotificationPreferences(),
              news_push: (this.$store.state.user.news_push_notifications !== undefined && this.$store.state.user.news_push_notifications === true) ? '1' : '0',
              user_age: (this.$store.state.user.isadult) ? '>=18' : '<18',
              test_spm: (this.isSPMUser()) ? '1' : '0'
            }
            window.TeamtipAppInterface.setFirebaseUserProperty(JSON.stringify(data))
          }
        }
        this.$gtag.config({ user_id: '' + this.$store.state.user.id })
        this.$gtag.pageview({
          page_title: this.$route.name,
          page_path: this.$route.path,
          page_location: window.location.href
        })
      })
      const ltr = new Date(this.getBGValue('spmltr'))
      this.setBGValue('spmltrc', new Date())
      if(ltr === undefined || ltr.getDate() !== new Date().getDate() || ltr.getFullYear() !== new Date().getFullYear() || ltr.getMonth() !== new Date().getMonth()) {
        if(this.$store.state.user && this.$store.state.user.status === 'active') {
          const data = {
            'id': '' + this.$store.state.user.id
          }
          this.$store.dispatch('refreshToken', data).then(response => {
          })
        }
      }
    }
    if ((!this.$store.state.user || !this.$store.state.user.lang) && this.$store.state.language) {
      Numeral.locale(this.$store.state.language)
      moment.locale(this.$store.state.language)
      if (this.$i18n.locale !== this.$store.state.language) {
        this.$log.debug('app created set i18n.locale ' + this.$store.state.language)
        this.$i18n.locale = this.$store.state.language
      } else {
        this.$log.debug('app created use i18n.locale ' + this.$i18n.locale)
      }
    }
    this.$log.debug("app created this.getBGValue('spmbgid'): " + this.getBGValue('spmbgid'))
    if(this.getBGValue('spmbgid') === 'null' || this.getBGValue('spmbgid') === undefined || this.getBGValue('spmbgid') === 'undefined') {
      this.clearBGValue('spmbgid')
      if(navigator.userAgent.indexOf('TEAMTIP') > 0 || navigator.userAgent.indexOf('Teamtip') > 0) {
        this.clearBGValue('betgameId')
      }
    }
    if(this.$route.params && this.$route.params.id && this.$route.params.code && this.$route.name === 'join') {
      this.$store.dispatch('checkInvitation', [this.$route.params.id, this.$route.params.code]).then(() => {
        this.setBGValue('spmbgid', this.$route.params.id)
        if (navigator.userAgent.indexOf('TEAMTIP') > 0 || navigator.userAgent.indexOf('Teamtip') > 0) {
          this.setBGValue('betgameId', this.$route.params.id)
        }
      }).catch(function (error) {
      })
    }
    if(this.$store.state.geoData === null) {
      this.$store.dispatch('getGeoData', []).then(response => {
        }, error => {
        })
    }
    if(this.$route.params && this.$route.params.id && this.$route.name === 'betgame') {
      const id = this.$route.params.id
      this.$log.debug("app created 1 bg.id: " + id + ' --- ' + this.$store.getters.loggedIn + ' --- ' + this.$store.getters.isUserConnectedToBetgame(id))
      if(parseInt(id) > 0) {
        if(this.$store.getters.loggedIn && this.$store.getters.isUserConnectedToBetgame(id)) {
          this.setBGValue('spmbgid', id)
        }
      }
    }
    if(this.getBGValue('spmbgid')) {
      const id = this.getBGValue('spmbgid')
      this.$log.debug("app created bg.id: " + id)
      if(parseInt(id) > 0) {
        this.$store.dispatch('setBetgameId', id)
        //this.$store.dispatch('fetchBetgameUsers', id)
        if (!this.$store.state.betgame || parseInt(this.$store.state.betgame.id) !== parseInt(id)) {
          this.$store.dispatch('fetchBetgame', id).then(() => {
            this.styleDocument()
          })
        } else {
          if (this.$store.state.betgame) {
            this.styleDocument()
          }
        }
        if (!this.$store.state.currentSeason) {
          this.$store.dispatch('fetchCurrentSeason', id)
        }
        if (this.$store.state.token && this.$store.state.token.length > 0 &&
            (!this.$store.state.leagueId || !this.$store.state.teams || this.$store.state.teams.length === 0)) {
          this.$store.dispatch('fetchBetgameLeague', id).then(() => {
            this.$store.dispatch('fetchTeams', this.$store.state.leagueId).then(() => {

            })
          })
        }
      }
    }
    if(this.getBGValue('userSource')) {
      this.$store.dispatch('setUserSource', this.getBGValue('userSource'))
    }
    this.$log.debug('app created before token')

    if(this.$store.getters.loggedIn && this.$store.state.user && parseInt(this.$store.state.user.id) > 285209 && 
      this.$store.state.user.status === 'validation_pending' && this.$store.state.user.external_login === '') {
      if(this.$router.currentRoute && this.$router.currentRoute.name && this.$router.currentRoute.name !== 'validateemailregistration') {
        this.$router.push({ name: 'validateemailregistration' })
      }
    } else if(this.$store.getters.loggedIn && this.$store.state.user && !this.$store.state.user.acceptedtos) {
      if(this.$router.currentRoute && this.$router.currentRoute.name && this.$router.currentRoute.name !== 'finishregistration' && 
        this.$router.currentRoute.name !== 'termsofuse' && this.$router.currentRoute.name !== 'privacy') {
        this.$router.push({ name: 'finishregistration' })
      }
    } else if(this.$store.state.token) {
      const r = window.localStorage.getItem('spmlr')
      this.$log.debug('app created before token lastr ' + r)
      if(r !== undefined && r !== null && r.length >= 0 && r !== 'undefined') {
        if(this.$route.query !== null && this.$route.query !== undefined) {
          this.$router.push({ name: r, query: this.$route.query }).catch(err => {
          })
        } else {
          this.$router.push({ name: r }).catch(err => {
          })
        }
      } else {
        this.$router.push({ name: 'dashboard' }).catch(err => {})
      }
    }
  },
  mounted: function () {
    this.$log.debug('app mounted '  + this.$route.query.id + ' --- ' + this.$route.query.code + ' --- ' + this.$route.query.email)

    /*
    const data = {
      '_id': '' + 103,
      'first_name': 'bob',
      'email': 'bob103@spm.spm',
      'password': '1234567890'
    }
    this.$store.dispatch('chatCreateUser', data).then(response => {
      this.$log.debug('chatCreateUser response: ' + JSON.stringify(response))
      this.$store.dispatch('chatLoginUser', {'user': data._id, 'password': data.password}).then(response => {
        this.$log.debug('chatLoginUser response: ' + JSON.stringify(response))
        this.$store.dispatch('chatCreateConversation', {
          'title': 'Test Conversation',
          'participant_ids': ['103']
        }).then(response => {
          this.$log.debug('chatCreateConversation response: ' + JSON.stringify(response))
        })
        .catch(function (error) {
          this.$log.debug('chatCreateConversation error: ' + JSON.stringify(error))
        })
      })
      .catch(function (error) {
        this.$log.debug('chatLoginUser error: ' + JSON.stringify(error))
      })
    })
    .catch(function (error) {
      this.$log.debug('chatCreateUser error: ' + JSON.stringify(error))
    })
    */
    
    const sentLastActive = this.getBGValue('spmsla')
    const sentLastActiveSeconds = (new Date() - new Date(sentLastActive)) / 1000
    if(sentLastActiveSeconds > (60 * 60 * 24) && this.$store.state.token && this.$store.state.user) {
      this.$store.dispatch('patchUser', { last_active: moment.tz(Date.now(), 'Europe/Berlin').format('YYYY-MM-DD HH:mm:ss') }).then(() => {
        this.setBGValue('spmsla', new Date())
      })
    }
    if(navigator.userAgent.indexOf('TEAMTIP') > 0 || navigator.userAgent.indexOf('Teamtip') > 0) {
      window.bgIsLoggedIn = this.bgIsLoggedIn
      window.bgRouterPush = this.bgRouterPush
      var index = navigator.userAgent.lastIndexOf('Teamtip/')
      if(index === -1) {
        index = navigator.userAgent.lastIndexOf('TEAMTIP/')
      }
      if(index > -1 && this.$store.state.token && this.$store.state.user) {
        const sentAppLastActive = this.getBGValue('spmsala')
        const sentAppLastActiveSeconds = (new Date() - new Date(sentAppLastActive)) / 1000
        const version = navigator.userAgent.substring(index + 8)
        const att = window.localStorage.getItem('trackingAuthorizationStatus')
        if(version && version.trim() !== '' && (this.$store.state.appVersion === '' || this.$store.state.appVersion !== version || sentAppLastActiveSeconds > (60 * 60 * 24))) {
          const pt = this.getPushToken()
          const firebaseId = this.firebaseInstallationId()
          if(pt !== '' && pt !== 'undefined') {
            const data = {
              push_token: pt,
              fk_user: this.$store.state.user.id,
              app_version: version,
              last_active: moment.tz(Date.now(), 'Europe/Berlin').format('YYYY-MM-DD HH:mm:ss'),
              firebase_id: firebaseId,
              status: '' + att
            }
            this.$store.dispatch('patchUserApp', data).then(response => {
              this.setBGValue('spmsala', new Date())
            })
          }
        }
      }
    }
    if(this.showValidationHint && this.$store.state.user && this.$store.state.user.status !== undefined && this.$store.state.user.status !== 'active') {
      this.$toast.open({ message: this.$i18n.t('register.please_finish_registration'),
        position: 'top',
        duration: TOAST_DURATION,
        type: 'error'
      })
    }

    if(this.$store.state.betgame && this.$store.state.user) {
      const uid = '' + this.$store.state.user.id
      const uem = '' + this.$store.state.user.email.charAt(0) + this.reverse(uid)
      const temp = this.reverse(String(this.$store.state.user.registration_date)).replaceAll('T', this.reverse(uem))
      .replaceAll(':', '').replaceAll('-', uem).concat(uid)
      const addParticipant = this.$store.state.betgame.chat && this.$store.state.betgame.chat !== '' && 
          !this.$store.state.chats_participant.includes(this.$store.state.betgame.chat)
      if(!this.$store.state.chat_token || this.$store.state.chat_token === '') {
        if(this.$store.state.user.chatuser && this.$store.state.user.chatuser !== '') {
            this.$store.dispatch('chatLoginUser', {'user': uid, 'password': temp}).then(response => {
              this.$log.debug('app mounted chatLoginUser response: ' + JSON.stringify(response))
              if(this.$store.state.user.chatuser !== uid + '-' + temp) {
                this.$store.dispatch('patchUser', {
                  chatuser: uid + '-' + temp
                })
              }
              if(addParticipant && this.$store.state.betgame.chat) {
                this.$store.dispatch('chatAddParticipant', { user: uid, chat: this.$store.state.betgame.chat }).then(response => {
                  this.$store.dispatch('fetchChatItems', true).then(() => {
                  })
                })
              } else if(this.$store.state.betgame.chat) {
                this.$store.dispatch('fetchChatItems', true).then(() => {
                })
              }
            })
        } else {
          const data = {
            '_id': uid,
            'first_name': this.$store.state.user.nickname,
            'email': this.$store.state.user.email,
            'password': temp
          }
          this.$store.dispatch('chatCreateUser', data).then(response => {
            this.$log.debug('app mounted chatCreateUser response: ' + JSON.stringify(response))
            this.$store.dispatch('patchUser', {
              chatuser: uid + '-' + temp
            })
            this.$store.dispatch('chatLoginUser', {'user': data._id, 'password': data.password}).then(response => {
              this.$log.debug('app mounted chatLoginUser response: ' + JSON.stringify(response))
              if(this.$store.state.betgame.chat) {
                this.$store.dispatch('chatAddParticipant', { user: uid, chat: this.$store.state.betgame.chat }).then(response => {
                  this.$store.dispatch('fetchChatItems', true).then(() => {
                  })
                })
              }
            })
            .catch(function (error) {
              this.$log.debug('app mounted chatLoginUser error: ' + JSON.stringify(error))
            })
          })
          .catch(function (error) {
            this.$log.debug('app mounted chatCreateUser error: ' + JSON.stringify(error))
          })
        }
      } else {
        const payload = jwt_decode(JSON.stringify(this.$store.state.chat_token))
        const a = payload.exp * 1000
        const b = moment()
        if(a < b) {
          this.$store.dispatch('chatLoginUser', {'user': uid, 'password': temp}).then(response => {
            this.$log.debug('app mounted chatLoginUser response: ' + JSON.stringify(response))
            if(addParticipant && this.$store.state.betgame.chat) {
              this.$store.dispatch('chatAddParticipant', { user: uid, chat: this.$store.state.betgame.chat }).then(response => {
                this.$store.dispatch('fetchChatItems', true).then(() => {
                })
              })
            } else if(this.$store.state.betgame.chat) {
              this.$store.dispatch('fetchChatItems', true).then(() => {
              })
            }
          })
        }
        if(!this.$store.state.user.chatuser.includes('-')) {
          this.$store.dispatch('patchUser', {
            chatuser: uid + '-' + temp
          })
        }
      }

      const createChat = this.isAdmin(this.$store.state.betgame.id) && (!this.$store.state.betgame.chat || this.$store.state.betgame.chat === '')
      if(createChat) {
        if(this.$store.state.chat_token && this.$store.state.chat_token !== '') {
          const payload = jwt_decode(JSON.stringify(this.$store.state.chat_token))
          const a = payload.exp * 1000
          const b = moment()
          if(a > b) {
            this.$store.dispatch('chatCreateConversation', {
              'title': this.$store.state.betgame.name,
              'participant_ids': [uid]
            }).then(response => {
              this.$log.debug('app mounted chatCreateConversation response: ' + JSON.stringify(response))
            })
            .catch(function (error) {
              this.$log.debug('app mounted chatCreateConversation error: ' + JSON.stringify(error))
            })
          }
        }
      } else {
        if(this.$store.state.betgame.chat && this.$store.state.betgame.chat !== '' && this.$store.state.chat_token && this.$store.state.chat_token !== '') {
          if (!this.$store.state.chats_participant.includes(this.$store.state.betgame.chat)) {
            this.$store.dispatch('chatAddParticipant', { user: this.$store.state.user.id, chat: this.$store.state.betgame.chat }).then(response => {
              this.$store.dispatch('fetchChatItems', true).then(() => {
              })
            })
          } else {
            this.$store.dispatch('fetchChatItems', true).then(() => {
            })
          }
          if (this.interval == null) {
            this.interval = setInterval(() => {
              this.$store.dispatch('fetchChatItems', true).then(() => {
                //Vue.$log.debug('App mounted fetchChatItems')
              })
            }, 10000)
          }
        }
      }
    }

    if(this.$store.state.showLoadingOverlay) {
      setTimeout(() => {
        var element = document.getElementById("pagebody")
        if(element) {
          element.classList.remove("bodybackground")
        }
        this.$store.dispatch('setShowLoadingOverlay', false)
      }, 3700);
    }

    const data = {
      "@context": "https://schema.org",
      "@graph": [
        {
          "@type": ["SoftwareApplication", "MobileApplication"],
          "@id": "https://teamtip.net#app",
          "name": "Teamtip",
          "applicationCategory": "SportsApplication",
          "operatingSystem": "iOS, Android, Web",
          "url": "https://teamtip.net",
          "image": "https://teamtip.net/images/Teamtip_Logo_180x180.png",
          "description": "Teamtip ist das Bundesliga Tippspiel für Freunde, Kollegen und Firmen. Erstelle kostenlos eigene Tipprunden, chatte mit deinen Freunden und verfolge die Bundesliga, WM, Champions League und andere Wettbewerbe live.",
          "publisher": {
            "@type": "Organization",
            "name": "Sportplatz Media GmbH",
            "url": "https://sportplatz-media.com"
          },
          "offers": {
            "@type": "Offer",
            "price": "0",
            "priceCurrency": "EUR"
          },
          "sameAs": [
            "https://apps.apple.com/de/app/teamtip-dein-tippspiel/id1496608495",
            "https://play.google.com/store/apps/details?id=com.sportplatzmedia.teamtip"
          ],
          "aggregateRating": {
            "@type": "AggregateRating",
            "ratingValue": "4.75",
            "ratingCount": "1532",
            "reviewAspect": "combined average of iOS (4.7/958) and Android (4.8/574)"
          },
          "inLanguage": this.$i18n.locale
        },
        {
          "@type": "Organization",
          "@id": "https://sportplatz-media.com#org",
          "name": "Sportplatz Media GmbH",
          "url": "https://sportplatz-media.com",
          "logo": "https://teamtip.net/images/Teamtip_Logo_180x180.png"
        },
        {
          "@type": "WebSite",
          "@id": "https://teamtip.net#website",
          "url": "https://teamtip.net",
          "name": "Teamtip",
          "publisher": { "@id": "https://sportplatz-media.com#org" },
          "inLanguage": this.$i18n.locale
        }
      ]
    }
    const s = document.createElement('script')
    s.type = 'application/ld+json'
    s.text = JSON.stringify(data)
    document.head.appendChild(s)
    
    if(this.$store.getters.loggedIn && this.$store.state.user && parseInt(this.$store.state.user.id) > 285209 && 
      this.$store.state.user.status === 'validation_pending' && this.$store.state.user.external_login === '') {
      if(this.$router.currentRoute && this.$router.currentRoute.name && this.$router.currentRoute.name !== 'validateemailregistration') {
        this.$router.push({ name: 'validateemailregistration' })
      }
    } else if(this.$store.getters.loggedIn && this.$store.state.user && !this.$store.state.user.acceptedtos) {
      if(this.$router.currentRoute && this.$router.currentRoute.name && this.$router.currentRoute.name !== 'finishregistration' &&
        this.$router.currentRoute.name !== 'termsofuse' && this.$router.currentRoute.name !== 'privacy') {
        this.$router.push({ name: 'finishregistration' })
      }
    }
  },
  beforeDestroy () {
    if(this.interval) {
      clearInterval(this.interval)
    }
  },
  methods: {
    closeSidebarPanel: menumutations.toggleNav,
    swipeHandler (direction) {
      this.closeSidebarPanel()
    },
    appResumeEventFunction() {
      this.$toast.open({ message: 'App.vue appResumeEventFunction',
        position: 'top',
        duration: TOAST_DURATION,
        type: 'success'
      })
      return 'appResumeEvent'
    },
    appPullToRefreshEventFunction() {
      this.$toast.open({ message: 'App.vue appPullToRefreshEventFunction',
        position: 'top',
        duration: TOAST_DURATION,
        type: 'success'
      })
      const r = this.$router.currentRoute.path
      return 'appPullToRefreshEvent'
    },
    getPushToken() {
      try {
        if (window.TeamtipAppInterface !== undefined && window.TeamtipAppInterface !== null) {
          return window.TeamtipAppInterface.getPushToken()
        } else if (window.webkit && window.webkit.messageHandlers.TeamtipAppInterface !== undefined && window.webkit.messageHandlers.TeamtipAppInterface !== null) {
          const b = window.webkit.messageHandlers.TeamtipAppInterface.postMessage('getPushToken')
          return window.localStorage.getItem('pushToken')
        } else {
          return ''
        }
      } catch (e) {
        return ''
      }
    },
    bgIsLoggedIn(data) {
      return this.$store.getters.loggedIn
    },
    bgRouterPush(path) {
      this.$router.push( path ).catch(err => {})
    },
    getNotificationPreferences() {
      var notification_preferences = ''
      if(this.$store.state.user) {
        if(this.$store.state.user.email_notifications !== undefined && this.$store.state.user.email_notifications === true) {
          notification_preferences += 'MReminder,'
        }
        if(this.$store.state.user.push_notifications !== undefined && this.$store.state.user.push_notifications === true) {
          notification_preferences += 'PReminder,'
        }
        if(this.$store.state.user.news_email_notifications !== undefined && this.$store.state.user.news_email_notifications === true) {
          notification_preferences += 'MNews,'
        }
        if(this.$store.state.user.news_push_notifications !== undefined && this.$store.state.user.news_push_notifications === true) {
          notification_preferences += 'PNews,'
        }
        if(this.$store.state.user.chat_push_notifications !== undefined && this.$store.state.user.chat_push_notifications === true) {
          notification_preferences += 'PChat,'
        }
      }
      if(notification_preferences === '') {
        notification_preferences = 'none'
      }
      return notification_preferences
    },
  },
  watch:{
    darkmode: {
      handler (value) {
        document.documentElement.setAttribute('data-theme', value ? 'dark' : 'light')
      },
      immediate: true
    },
    $route (to, from){
      // this.$log.debug(from.path + " --- " + to.patch + " --- " + this.$router.currentRoute.path)
    }
  }
}
</script>

<style lang="scss">
  
  @import './assets/styles/global.scss';

  #app {
    height: 100%;
  }
  
  .pageoffset {
    padding-top: 64px !important;
  }
  
</style>
